import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center q-pb-xs" }
const _hoisted_2 = { class: "q-pr-sm" }
const _hoisted_3 = {
  id: "div-01",
  class: "row no-wrap items-center"
}
const _hoisted_4 = { style: {"max-height":"100px","overflow-y":"scroll","width":"100%"} }
const _hoisted_5 = {
  id: "div-03",
  class: "col-auto"
}

import ModalFilterPcs						from '@/views/modals/ModalFilterPcs.vue';
import ModalFilterExcludePcs						from '@/views/modals/ModalFilterExcludePcs.vue';
import ModalConfirmationDialog 	from '@/views/modals/ModalConfirmationDialog.vue';
import { EnumButtonSizes }			from '@/enums/enums';
import { useCampaignStore }			from '@/stores/campaignStore';
import { usePagesUtilStore }		from '@/stores/pagesUtilStore';
import { computed }							from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CampaignPCs',
  setup(__props) {

const campaignStore   = useCampaignStore();
const pagesUtilStore  = usePagesUtilStore();

const removePcIdFromPcsIds = (pcIdToRemove: number) => {
	const index = campaignStore.focusedCampaign.pcsIds.indexOf(pcIdToRemove, 0);

	if (index > -1) {
		campaignStore.focusedCampaign.pcsIds.splice(index, 1);
	}
};

const onRemove = (
	scope: {
    index: number;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
    opt: any;
    selected: boolean;
    removeAtIndex: (index: number) => void;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
    toggleOption: (opt: any) => void;
    tabindex: number;
	}
) => {
	scope.removeAtIndex(scope.index);

	removePcIdFromPcsIds(scope.opt.codpontocaptura);
};

const disableClearBtn = computed(() => {
	try {
		return (campaignStore.focusedCampaign.pcs.length == 0);
		
	} catch (error) {
		return false;
	}
});

/*const onClearBtnClick = () => {
  pagesUtilStore.showModalConfirmationDialog = true;
};*/

//NOVO
const onClearPcsBtnClick = () => {
  pagesUtilStore.showModalConfirmationDialogPcs = true;
};

const onClearSelectedPcsConfirmation = () => {
	campaignStore.focusedCampaign.pcs.length = 0;
};

const onFilterBtnClick = () => {
  //pagesUtilStore.showModalPCs = true;
  pagesUtilStore.showModalFilterPCs = true;

};

const onFilterExcludeBtnClick = () => {
	console.log("teste")
  pagesUtilStore.showModalFilterExcludePCs = true;

};

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", {
        id: "span-01",
        class: "midia-app-label-sm q-pr-sm"
      }, "PCs *", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_c_q_btn, {
          id: "btn-clear",
          propBtnLabel: "Limpar",
          propBtnFunction: onClearPcsBtnClick,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).SMALL,
          disable: disableClearBtn.value
        }, null, 8, ["propBtnSize", "disable"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_c_q_btn, {
          id: "btn-clear",
          propBtnLabel: "Excluir",
          propBtnFunction: onFilterExcludeBtnClick,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).SMALL,
          disable: disableClearBtn.value
        }, null, 8, ["propBtnSize", "disable"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_select, {
          modelValue: _unref(campaignStore).focusedCampaign.pcs,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(campaignStore).focusedCampaign.pcs) = $event)),
          color: "globalAppPrimaryColor",
          "bg-color": "globalAppDefaultBackgroundColor",
          outlined: "",
          dense: "",
          "hide-dropdown-icon": "",
          "use-chips": "",
          multiple: ""
        }, {
          "selected-item": _withCtx((scope) => [
            _createVNode(_component_q_chip, {
              removable: "",
              onRemove: ($event: any) => (onRemove(scope)),
              tabindex: scope.tabindex,
              color: "globalAppPrimaryColor",
              "text-color": "globalAppDefaultBackgroundColor",
              class: "q-ma-xs",
              size: "sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.opt.codpontocaptura) + " - " + _toDisplayString(scope.opt.nompontocaptura), 1)
              ]),
              _: 2
            }, 1032, ["onRemove", "tabindex"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_c_q_btn, {
          id: "btn-filtrar",
          propBtnLabel: "Filtrar",
          propBtnFunction: onFilterBtnClick,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"])
      ])
    ]),
    _createVNode(ModalFilterPcs),
    _createVNode(ModalFilterExcludePcs),
    _createVNode(ModalConfirmationDialog, {
      propDialogTitle: "Atenção!",
      propConfirmationMsg: "Tem certeza de que deseja excluir todos os PCs selecionados?",
      propDialogType: "pcs",
      onConfirm: onClearSelectedPcsConfirmation
    })
  ]))
}
}

})